<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: "form-add-praktikum",
  props: ["idPembelajaran"],
  data() {
    return {
      pratikum_nama: "",
      pratikum_kode: "",
      pratikum_data: [],
      pratikum_ref: [],
      isAddMaster: false,
    };
  },
  mounted() {},
  methods: {
    validationForm() {
      if (this.pratikum_nama == "" || this.pratikum_kode == "") {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terdapat inputan kosong!",
        });
        return;
      }
      this.storeDataMaster();
    },
    storeDataMaster() {
      let self = this;
      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
      });

      var config_store_data = {
        method: "post",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION + "master/data-laboratorium",
        data: {
          lab_kode: self.pratikum_kode,
          lab_nama: self.pratikum_nama,
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config_store_data)
        .then(function (response) {
          console.log(response);
          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: "Data berhasil di simpan.",
            timer: 2000,
            timerProgressBar: true,
            showCancelButton: false,
            showConfirmButton: false,
          }).then((result) => {
            /* Read more about handling dismissals below */
            if (result.dismiss === Swal.DismissReason.timer) {
              self.resetInputPraktikumMaster();
              self.isAddMaster = false;
              Swal.close();
            }
          });
        })
        .catch(function (error) {
          Swal.close();
          self.axiosCatchError = error.response.data.data;
        });
    },
    resetInputPraktikumMaster() {
      this.pratikum_kode = "";
      this.pratikum_nama = "";
    },
    addRowPraktikum() {
      let self = this;
      self.pratikum_data.push({
        pratikum_data: "",
      });
    },
    deleteRow(index, row_data) {
      let self = this;
      var idx = self.pratikum_data.indexOf(row_data);
      if (idx > -1) {
        self.pratikum_data.splice(idx, 1);
      }
    },
    onSearchPratikum(search, loading) {
      if (search.length) {
        loading(true);
        this.searchPratikum(loading, search, this);
      }
    },
    searchPratikum: function (loading, search) {
      let self = this;
      var config = {
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "referensi/search-data-pratikum",
        params: {
          search: search,
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };
      axios(config).then((response) => {
        if (response.data.meta.code == 200) {
          self.pratikum_ref = response.data.data.referensi;
          loading(false);
        } else {
          self.peserta_ref = [
            {
              a_id: 0,
              materi: "-",
            },
          ];
          loading(false);
        }
      });
    },
    storeData() {
      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      const conf = {
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "transactions/pra-pelaksanaan/praktikum",
        method: "post",
        data: {
          pratikum_data: JSON.stringify(this.pratikum_data),
          idPembelajaran: this.idPembelajaran,
          userId: localStorage.session_user_id,
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(conf).then((res) => {
        console.log(res);
        Swal.fire({
          icon: "success",
          title: "Berhasil",
          text: "Data berhasil di simpan, jika ada data duplikat maka data tidak akan masuk ke sistem.",
          timer: 2000,
          timerProgressBar: true,
          showCancelButton: false,
          showConfirmButton: false,
        }).then((result) => {
          /* Read more about handling dismissals below */
          if (result.dismiss === Swal.DismissReason.timer) {
            Swal.close();
            this.$emit("refresh-table", true);
          }
        });
      });
    },
  },
};
</script>
<template>
  <b-form class="p-2" @submit.prevent="validationForm">
    <div class="row mb-2">
      <div class="col-12">
        <div class="">
          <button
            v-if="isAddMaster == false"
            type="button"
            @click="isAddMaster = true"
            class="btn btn-sm btn-success"
          >
            <i class="fa fa-plus"></i> Tambah Praktikum Master
          </button>
          <button
            v-else
            type="button"
            @click="isAddMaster = false"
            class="btn btn-sm btn-warning"
          >
            <i class="fa fa-times"></i> Tutup Praktikum Master
          </button>
        </div>
      </div>
    </div>
    <div v-if="isAddMaster == true" class="row">
      <div class="col-lg-12 mt-1">
        <b-form-group label="Kode" label-for="pratikum_kode">
          <b-form-input
            id="pratikum_kode"
            placeholder="Masukkan Kode..."
            type="text"
            v-model="pratikum_kode"
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col-lg-12 mt-1">
        <b-form-group label="Nama" label-for="pratikum_nama">
          <b-form-input
            id="pratikum_nama"
            placeholder="Masukkan Nama..."
            type="text"
            v-model="pratikum_nama"
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col-lg-6">&nbsp;</div>
      <div class="col-lg-6">
        <div class="text-end">
          <b-button type="reset" variant="danger">
            <i class="fa fa-redo-alt"></i> Reset
          </b-button>
          &nbsp;
          <b-button type="submit" variant="primary">
            <i class="fa fa-save"></i> Simpan
          </b-button>
        </div>
      </div>
      <!-- end col -->
    </div>
  </b-form>
  <b-form class="p-2" @submit.prevent="storeData">
    <div v-if="isAddMaster == false">
      <table class="table mb-0 mt-0 table-bordered table-condensed table-hover">
        <thead class="bg-dark text-center text-white">
          <tr>
            <th style="width: 50px">No</th>
            <th style="width: auto">Praktikum</th>
            <th style="width: 50px" class="text-center">
              <b-button
                type="button"
                class="btn btn-success btn-sm"
                v-on:click="addRowPraktikum"
              >
                <i class="fa fa-plus"></i>
              </b-button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row_data, key_data) in pratikum_data" :key="key_data">
            <td class="text-center">{{ key_data + 1 }}.</td>
            <td>
              <v-select
                label="pratikum_master_ket"
                v-model="row_data.pratikum_data"
                :options="pratikum_ref"
                @search="onSearchPratikum"
                placeholder="Cari dan Pilih Praktikum..."
              >
              </v-select>
            </td>
            <td>
              <div class="text-center">
                <div
                  class="btn btn-sm btn-danger"
                  v-on:click="deleteRow(key_data, row_data)"
                >
                  <i class="fa fa-minus"></i>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <hr />
      <div class="row">
        <div class="col-lg-6">&nbsp;</div>
        <div class="col-lg-6 mb-4">
          <div class="text-end">
            <b-button type="reset" variant="danger">
              <i class="fa fa-redo-alt"></i> Reset
            </b-button>
            &nbsp;
            <b-button type="submit" variant="primary">
              <i class="fa fa-save"></i> Simpan
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </b-form>
</template>
